import { defineProperty as _defineProperty, inherits as _inherits, classCallCheck as _classCallCheck, possibleConstructorReturn as _possibleConstructorReturn, getPrototypeOf as _getPrototypeOf, assertThisInitialized as _assertThisInitialized, createClass as _createClass, objectSpread as _objectSpread, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { marginBottomLevels, eventBus, getMarginBottomClass, Announce } from '@piggybank/core';
import pick from 'lodash/fp/pick';
import omit from 'lodash/fp/omit';
import isEmpty from 'lodash/fp/isEmpty';
import debounce from 'lodash/debounce';

var FormikForm = /*#__PURE__*/function (_Component) {
  _inherits(FormikForm, _Component);

  function FormikForm(props) {
    var _this;

    _classCallCheck(this, FormikForm);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormikForm).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "createDebouncedOnChange", function (debouncedOnChange) {
      _this.handleChangeIdle = debounce(debouncedOnChange, 300);
    });

    if (_this.props.debouncedOnChange) {
      _this.createDebouncedOnChange(_this.props.debouncedOnChange);
    }

    _this.state = {
      submitCount: 0
    };
    return _this;
  }

  _createClass(FormikForm, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props = this.props,
          formik = _this$props.formik,
          debouncedOnChange = _this$props.debouncedOnChange;

      if (debouncedOnChange && debouncedOnChange !== prevProps.debouncedOnChange) {
        this.createDebouncedOnChange(debouncedOnChange);
      }

      if (this.handleChangeIdle && formik.values !== prevProps.formik.values) {
        this.handleChangeIdle.cancel();
        this.handleChangeIdle(formik.values);
      } // Only try firing onError when form is submitted


      if (!formik.isSubmitting && !formik.isValidating && formik.submitCount > 0 && this.state.submitCount > prevState.submitCount && !isEmpty(formik.errors)) {
        eventBus.dispatch({
          type: 'onError',
          component: 'Form',
          values: formik.values,
          errors: formik.errors
        }); // Create formikBag as per
        // https://github.com/jaredpalmer/formik/blob/master/docs/api/withFormik.md#handlesubmit-values-values-formikbag-formikbag--void

        var formikBag = _objectSpread({}, this.props, pick(['resetForm', 'setErrors', 'setFieldError', 'setFieldTouched', 'setFieldValue', 'setStatus', 'setSubmitting', 'setTouched', 'setValues'], formik));

        this.props.onError({
          errors: formik.errors,
          values: formik.values,
          formikBag: formikBag
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _omit = omit(['debouncedOnChange'], this.props),
          formik = _omit.formik,
          marginBottom = _omit.marginBottom,
          textMap = _omit.textMap,
          children = _omit.children,
          rest = _objectWithoutProperties(_omit, ["formik", "marginBottom", "textMap", "children"]);

      var announcement = '';

      if (formik.status && formik.status.fieldErrorAnnouncement) {
        announcement = "".concat(textMap.errorAnnouncementPrefix).concat(formik.status.fieldErrorAnnouncement);
      }

      return React.createElement("form", _extends({
        className: cn('Form', getMarginBottomClass(marginBottom)),
        onSubmit: formik.handleSubmit,
        noValidate: true
      }, rest), React.createElement(Announce, null, announcement), typeof children === 'function' ? children(formik) : children);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      if (!props.formik.isSubmitting && !props.formik.isValidating && props.formik.submitCount > 0) {
        return {
          submitCount: props.formik.submitCount
        };
      }

      return null;
    }
  }]);

  return FormikForm;
}(Component);

_defineProperty(FormikForm, "defaultProps", {
  onError: function onError() {}
});

FormikForm.propTypes = process.env.NODE_ENV !== "production" ? {
  formik: PropTypes.shape({
    errors: PropTypes.object,
    isSubmitting: PropTypes.bool,
    isValidating: PropTypes.bool,
    resetForm: PropTypes.func,
    setErrors: PropTypes.func,
    setFieldError: PropTypes.func,
    setFieldTouched: PropTypes.func,
    setFieldValue: PropTypes.func,
    setStatus: PropTypes.func,
    setSubmitting: PropTypes.func,
    setTouched: PropTypes.func,
    setValues: PropTypes.func,
    submitCount: PropTypes.number,
    values: PropTypes.object
  }).isRequired,

  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottom: PropTypes.oneOf(marginBottomLevels),
  textMap: PropTypes.shape({
    errorAnnouncementPrefix: PropTypes.string
  }),
  onError: PropTypes.func,
  debouncedOnChange: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
} : {};
FormikForm.displayName = 'FormikForm';
export default FormikForm;